import React from 'react';
import { TbHash } from 'react-icons/tb';
import { formatCartId, formatCurrency } from '../../../Utils/Formatters';
import { getOrderColorByStatusId } from '../../../Utils/Constants/Order';
import Badge from '../Badge';

interface CardProfileOrderProps {
    order: any;
    onClick: CallableFunction;
}

const CardProfileOrder = ({order, onClick}: CardProfileOrderProps) => {

    return (
        <div onClick={() => onClick(order)} className="grid grid-cols-4 gap-2 p-1.5 w-full hover:bg-gray-100 cursor-pointer transition-all ease-in-out">
            <div className="grid grid-cols-2 font-bold">
                <span className="flex items-center"><span><TbHash /></span>{ formatCartId(order.id) }</span>
            </div>
            <span className="flex items-center w-full leading-none">{order.created_at}</span>
            <span className="flex items-center justify-end">{ formatCurrency(order.total) }</span>

            <span className="flex items-center justify-end">
                <Badge type={getOrderColorByStatusId(Number(order.status))} className="leading-4">
                    { order.status_name }
                </Badge>
            </span>

        </div>
        )
    }

export default CardProfileOrder;